import VirtualHumanEmbed from '@core/components/VirtualHumanManager/components/VirtualHumanEmbed';
import styled, { createGlobalStyle, css } from 'styled-components';

export const GlobalStyleForVHPublicPlayer = createGlobalStyle`
  #root {
    overflow: hidden;
  }
`;

export const MobileMessage = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
  height: 100svh;
  justify-content: center;
  align-items: center;
`;

export const VirtualHuman = styled(VirtualHumanEmbed)`
  ${({ show }) =>
    show
      ? css`
          position: relative;
        `
      : css`
          position: absolute;
          visibility: hidden;
          pointer-events: none;
          top: 0;
          left: 0;
        `}
`;
